// src/pages/customer/customerwidgets/StatCard.jsx
import React from 'react';

export default function StatCard({ icon, label, value, sub, color = 'text-primary' }) {
  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm border border-outline-variant/10
                    flex items-center gap-4">
      <div className={`w-11 h-11 rounded-xl flex items-center justify-center
                       bg-surface-container ${color}`}>
        <span className="material-symbols-outlined text-[22px]">{icon}</span>
      </div>
      <div>
        <p className="text-[11px] font-semibold text-on-surface-variant uppercase tracking-wider">
          {label}
        </p>
        <p className="text-2xl font-black text-on-surface leading-tight">{value}</p>
        {sub && <p className="text-[10px] text-secondary mt-0.5">{sub}</p>}
      </div>
    </div>
  );
}
